import { render } from "./QuestionareList.vue?vue&type=template&id=bffc0f32&scoped=true"
import script from "./QuestionareList.vue?vue&type=script&lang=js"
export * from "./QuestionareList.vue?vue&type=script&lang=js"

import "./QuestionareList.vue?vue&type=style&index=0&id=bffc0f32&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bffc0f32"]])

export default __exports__